"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SystemProvider = SystemProvider;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _react2 = require("@emotion/react");
var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));
var _theme = _interopRequireDefault(require("./theme"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

// design system provider which adds all the required providers for design system components
function SystemProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_styles.StylesProvider, {
    injectFirst: true
  }, /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: _theme.default
  }, /*#__PURE__*/_react.default.createElement(_react2.ThemeProvider, {
    theme: _theme.default
  }, /*#__PURE__*/_react.default.createElement(_CssBaseline.default, null), children)));
}